import(/* webpackMode: "eager" */ "/home/runner/work/lovingnext/lovingnext/src/app/bulk-card-order/page.tsx");
